import React from 'react';
import { ZohoButton } from './ZohoButton';
import { Environment, getEnvironment } from '@/utils/env';

const DEV_URL =
  'https://crmsandbox.zoho.eu/crm/vytalcrmsandbox/tab/CustomModule4/';
const PROD_URL =
  'https://one.zoho.eu/zohoone/vytalglobal/home/cxapp/crm/vytalglobal/tab/CustomModule6/';

interface ZohoStoreButtonProps {
  externalZohoId: string;
  className?: string;
  label?: string;
}

export const ZohoStoreButton: React.FC<ZohoStoreButtonProps> = ({
  externalZohoId,
  className,
  label,
}) => {
  const baseUrl =
    getEnvironment() === Environment.Production ? PROD_URL : DEV_URL;
  const href = `${baseUrl}${externalZohoId}`;

  return <ZohoButton href={href} className={className} label={label} />;
};
